"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ObjectHelper_1 = require("@aurora/shared-utils/helpers/objects/ObjectHelper");
// eslint-disable-next-line unicorn/prefer-node-protocol
const http_1 = require("http");
// eslint-disable-next-line unicorn/prefer-node-protocol
const https_1 = require("https");
// see https://nodejs.org/dist/latest-v16.x/docs/api/http.html#http_new_agent_options for API
const keepAlive = process.env.NODE_FETCH_KEEP_ALIVE === 'true';
const keepAliveMsecs = process.env.NODE_FETCH_KEEP_ALIVE_MS;
const maxSockets = process.env.NODE_FETCH_MAX_SOCKETS;
const maxTotalSockets = process.env.NODE_FETCH_MAX_TOTAL_SOCKETS;
const maxFreeSockets = process.env.NODE_FETCH_MAX_FREE_SOCKETS;
const scheduling = process.env.NODE_FETCH_SCHEDULING;
const timeout = process.env.NODE_FETCH_TIMEOUT;
const agentOptions = {
    keepAlive,
    keepAliveMsecs: (0, ObjectHelper_1.asNumber)(keepAliveMsecs),
    maxSockets: (0, ObjectHelper_1.asNumber)(maxSockets),
    maxTotalSockets: (0, ObjectHelper_1.asNumber)(maxTotalSockets),
    maxFreeSockets: (0, ObjectHelper_1.asNumber)(maxFreeSockets),
    scheduling: scheduling,
    timeout: timeout ? Number(timeout) : undefined
};
const httpAgent = new http_1.Agent(agentOptions);
const httpsAgent = new https_1.Agent(agentOptions);
const agent = (url) => {
    return url.protocol === 'http:' ? httpAgent : httpsAgent;
};
exports.default = agent;
//# sourceMappingURL=fetchAgent.js.map